import { Box, Button, IconButton } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const Pagination = ({ pagination }) => {
    const { currentPage, totalPages } = pagination;
    const [searchParams, setSearchParams] = useSearchParams();

    const changePage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams);
    };

    if (totalPages <= 1) return null;

    const generatePageNumbers = () => {
        const pages = [];
        const maxVisible = 5;

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            if (currentPage <= 3) {
                pages.push(1, 2, 3, 4, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }

        return pages;
    };

    const pages = generatePageNumbers();

    return (
        <Box display="flex" justifyContent="center" gap={1} mt={4} flexWrap="wrap">
            <IconButton onClick={() => changePage(1)} disabled={currentPage === 1}>
                &laquo;
            </IconButton>

            <IconButton onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>
                <ChevronLeftIcon />
            </IconButton>

            {pages.map((page, i) =>
                page === '...' ? (
                    <Box key={i} px={1} pt={1.1}>
                        ...
                    </Box>
                ) : (
                    <Button
                        key={page}
                        variant={page === currentPage ? 'contained' : 'outlined'}
                        onClick={() => changePage(page)}
                        sx={{ width: '30px', height: '30px', minWidth: '30px', borderRadius: '15px', alignSelf: 'center' }}
                    >
                        {page}
                    </Button>
                )
            )}

            <IconButton onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>
                <ChevronRightIcon />
            </IconButton>

            <IconButton onClick={() => changePage(totalPages)} disabled={currentPage === totalPages}>
                &raquo;
            </IconButton>
        </Box>
    );
};

export default Pagination;
